import React from "react";
import { Card, SectionTitle } from "@/components/layout/PageShell";
import { cn } from "@/lib/utils";

/**
 * Standard data table card for Report Center — sticky header, dense rows.
 */
export function ReportTableCard({
  title,
  children,
  className,
  bodyClassName,
  actions,
  dense = true,
}) {
  return (
    <Card
      className={cn("p-0 mb-3 overflow-hidden border-[#F0E0D4]", className)}
      data-testid="report-table-card"
    >
      {(title || actions) && (
        <div className="px-3 py-2 border-b border-[#F0E0D4] bg-[#FFF8F3] flex items-center justify-between gap-2">
          {title ? <SectionTitle className="!mb-0 text-[13px]">{title}</SectionTitle> : <span />}
          {actions}
        </div>
      )}
      <div className={cn("overflow-x-auto report-table-scroll", bodyClassName)}>
        <div className={cn(dense && "report-table")}>{children}</div>
      </div>
    </Card>
  );
}
